import { OrderCustomerState } from "@/models/Orders/OrderEnums";

export function orderCustomerStateToText(orderState: OrderCustomerState) {
  switch (orderState) {
    case OrderCustomerState.Concept:
      return "Koncept";
    case OrderCustomerState.InProgress:
      return "Rozpracovaná";
    case OrderCustomerState.Cancelled:
      return "Zrušená";
    case OrderCustomerState.Confirmed:
      return "Potvrzená";
    case OrderCustomerState.NotFilled:
      return "Neuspokojená";
    case OrderCustomerState.Sent:
      return "Odeslaná";

    default:
      return "";
  }
}
